import { indexItems } from '@/mocks/homeData';

export default function Index() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">吃瓜索引</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[600px] mx-auto">
            按分类快速浏览你感兴趣的内容，总有一个话题适合你
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 max-w-[960px] mx-auto">
          {indexItems.map((item, i) => (
            <a
              key={i}
              href="#ranking"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="flex items-center gap-4 p-4 md:p-5 bg-background-100 border border-background-200/70 rounded-lg hover:border-primary-200 hover:bg-primary-50/20 transition-all duration-200 group cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100/70 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300 shrink-0">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-0.5">
                  <h3 className="text-sm md:text-base font-medium text-foreground-800 group-hover:text-primary-500 transition-colors">
                    {item.category}
                  </h3>
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{item.count}条</span>
                </div>
                <p className="text-xs md:text-sm text-foreground-600">{item.desc}</p>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-400 group-hover:text-primary-500 transition-colors shrink-0"></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}